import React from "react";
import styled from "styled-components"; //eslint-disable-line
import tw from "twin.macro";
import {ReactComponent as SvgDecoratorBlob1} from "images/svg-decorator-blob-9.svg";
import {Container, ContentWithPaddingXl} from "components/misc/Layouts";
import {PrimaryButton as PrimaryButtonBase} from "components/misc/Buttons";
import {SectionHeading} from "components/misc/Headings";


const Heading = tw(SectionHeading)`w-full`;
const HighlightedText = tw.span`text-primary-500`;

const PrimaryBackgroundContainer = tw.div`py-20 lg:py-24 bg-secondary-600 rounded-lg relative`
const Row = tw.div`px-8 mx-auto flex items-center relative z-10 flex-col lg:flex-row text-center`;

const ColumnContainer = tw.div`lg:w-full mx-auto`
const TextContainer = tw(ColumnContainer)``;
const Description = tw.p`mb-6 max-w-2xl mx-auto text-center text-sm md:text-base lg:text-lg font-normal leading-relaxed text-white`;

const DecoratorBlobContainer = tw.div`absolute inset-0 overflow-hidden rounded-lg`
const DecoratorBlob1 = tw(SvgDecoratorBlob1)`absolute bottom-0 left-0 w-80 h-80 transform -translate-x-20 translate-y-32 text-secondary-700 opacity-50`
const DecoratorBlob2 = tw(SvgDecoratorBlob1)`absolute top-0 right-0 w-80 h-80 transform  translate-x-20 -translate-y-64 text-secondary-700 opacity-50`

const PrimaryButton = styled(PrimaryButtonBase)(props => [
    tw`mt-8 md:mt-8 text-sm inline-block mx-auto md:mx-0`,
    props.buttonRounded && tw`rounded-full`
]);

export default ({
  pushDownFooter = true,
                    onClick
}) => {
  return (
    <Container css={pushDownFooter && tw`mb-20 lg:mb-24`}>
      <ContentWithPaddingXl style={{ paddingTop: 0 }}>
          <Heading>
              Diagnose Earlier –
              <HighlightedText>Before Damage Becomes Visible</HighlightedText>
          </Heading>
          <Description style={{ textAlign: "center", color: "#131E47" }}>
              Traditional scans often miss early dysfunction.
              MRI-MAI™ detects movement abnormalities and subtle changes even when structural MRI appears normal — helping you catch musculoskeletal issues, instability, or dysfunction earlier.

          </Description>
      <PrimaryBackgroundContainer>
        <Row>
          <TextContainer>
              <Description>
                  MRI appears normal — helping you catch musculoskeletal issues, instability, or dysfunction earlier.
            </Description>
                <Description>
                    Waiting weeks for MRI reports or consultant input delays care.
                </Description>
              <Description>
                  With MRI-MAI™, you get a complete structure + function report in minutes, streamlining triage and accelerating treatment planning.
              </Description>
              <PrimaryButton buttonRounded onClick={onClick ? onClick : () => window.open("https://app.maimotion.com", "_blank")}>
                  SCAN NOW FOR FREE
              </PrimaryButton>
          </TextContainer>
        </Row>
        <DecoratorBlobContainer>
          <DecoratorBlob1/>
          <DecoratorBlob2/>
        </DecoratorBlobContainer>
      </PrimaryBackgroundContainer>
      </ContentWithPaddingXl>
    </Container>
  );
};
